export default function app(onReady) {
    const readyState = document.readyState;

    if (readyState === 'interactive' || readyState === 'complete') {
        onReady();
    } else {
        document.addEventListener('DOMContentLoaded', onReady);
    }
}
